module.exports = __webpack_public_path__ + "static/media/Team 25 - Aquagreen.31bfae18.png";